var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"page-wrapper"},[_c('h2',{staticClass:"flex-shrink-0 mb-6"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('PermissionsTable',{attrs:{"permissions":_vm.permissions,"settablePermissions":_vm.settablePermissions,"linkToName":_vm.detailPageName,"tableHeight":_vm.tableHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }